import {
  createFileRoute,
  linkOptions,
  redirect,
} from '@tanstack/react-router';

const garyRequestLinkOptions = linkOptions({
  to: '/mydigitalworkers/gary/about',
  from: '/mydigitalworkers/gary',
});

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/gary/_garyLayout/',
)({
  beforeLoad: () => {
    throw redirect(garyRequestLinkOptions);
  },
});
